import { render, staticRenderFns } from "./new-passwords-form.vue?vue&type=template&id=3880f4b8&"
import script from "./new-passwords-form.vue?vue&type=script&lang=js&"
export * from "./new-passwords-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports